import { render } from "./CompanyStatistic.vue?vue&type=template&id=310cd041"
import script from "./CompanyStatistic.vue?vue&type=script&lang=js"
export * from "./CompanyStatistic.vue?vue&type=script&lang=js"

import exportComponent from "/builds/nex/company-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__